import styled from "styled-components";
//@ts-ignore
import reset from "./imgs/reset1.png";
//@ts-ignore
import stop from "./imgs/stop.png";
//@ts-ignore
import play from "./imgs/play.png";

import { useEffect, useState } from "react";

const Footer = ({
  onResetChat,
  onStopChat,
  onPlayChat,
  isAvatar,
}: {
  onResetChat: () => void;
  onStopChat: () => void;
  onPlayChat: () => void;
  isAvatar: boolean;
}) => {
  const [isaudioPlay, setIsAudioPlay] = useState(true);
  const [statusPlay, setStatusPlay] = useState("play");

  useEffect(() => {
    const audio = document.getElementById("myAudio") as HTMLAudioElement;

    const handlePlay = () => {
      setStatusPlay("stop");
      setIsAudioPlay(true);
    };

    const handlePause = () => {
      setStatusPlay("play");
      setIsAudioPlay(false);
    };

    audio?.addEventListener("play", handlePlay);
    audio?.addEventListener("pause", handlePause);

    // 초기 상태 설정
    if (audio) {
      setStatusPlay(audio.paused ? "play" : "stop");
      setIsAudioPlay(!audio.paused);
    }

    return () => {
      audio?.removeEventListener("play", handlePlay);
      audio?.removeEventListener("pause", handlePause);
    };
  }, [isAvatar]);

  const onChangeStatusStop = () => {
    setStatusPlay("play");
    onStopChat();
    setIsAudioPlay(false);
  };

  const onChangeStatusPlay = () => {
    setStatusPlay("stop");
    onPlayChat();
    setIsAudioPlay(true);
  };

  return (
    <Wrapper>
      <button>
        <img
          src={reset}
          width={24}
          height={24}
          alt="reset"
          onClick={onResetChat}
        />
        {statusPlay === "stop" ? (
          <img
            src={stop}
            width={28}
            height={28}
            alt="stop"
            onClick={onChangeStatusStop}
          />
        ) : (
          <img
            src={play}
            width={28}
            height={28}
            alt="play"
            onClick={onChangeStatusPlay}
          />
        )}

        {/* <p>새로 시작하기</p> */}
      </button>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  position: fixed;
  bottom: 50px;
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  > button {
    display: flex;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 68px;
    background-color: rgba(250, 250, 250, 0.7);
    margin: 0 auto;
    border: 1px solid rgba(234, 234, 234, 1);

    > p {
      width: 100%;
      font-size: 12px;
      color: rgba(76, 80, 84, 1);
      font-weight: 500;
    }

    > img {
      margin: 0 5px;
    }
  }
`;
